export default {
  name: 'slide',
  data () {
    return {
      imgLoaded: false,
      touchStartX: 0,
      touchEnd: 0
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    preload: {
      type: Boolean,
      default: false
    },
    noCaption: Boolean
  },
  computed: {
    isImage () {
      return this.data && this.data.acf_fc_layout === 'image'
    },
    text () {
      return !this.isImage && this.data.text
    },
    title () {
      return this.data.title
    },
    link () {
      return this.data.link &&
        this.data.link.replace(window.location.origin, '')
    },
    titleEl () {
      return this.link ? 'router-link' : 'span'
    },
    description () {
      if (!this.isImage) return false
      return this.data.image.caption || this.data.image.description
    }
  },
  methods: {
    advance () {
      this.$emit('advance')
    },
    retreat () {
      this.$emit('retreat')
    },
    handleTouchStart (event) {
      this.touchStartX = event.changedTouches[0].screenX
    },
    handleTouchMove (event) {
      this.touchEndX = event.changedTouches[0].screenX
    },
    handleTouchEnd () {
      if (this.touchEndX < this.touchStartX - 50) {
        this.advance() // Swipe left
      } else if (this.touchEndX > this.touchStartX + 50) {
        this.retreat() // Swipe right (implement retreat if needed)
      }
    }
  },
  render (createElement) {
    if (this.isImage) {
      let kids = [
        createElement('responsive-image', {
          props: {
            src: this.data.image,
            preload: this.preload,
            background: false
          },
          nativeOn: {
            click: this.advance,
            lazybeforeunveil: () => {
              this.imgLoaded = true
            },
            touchstart: this.handleTouchStart,
            touchmove: this.handleTouchMove,
            touchend: this.handleTouchEnd
          }
        })
      ]
      if (this.data.title) {
        kids.push(createElement('figcaption', {
          'class': ['figcaption line-height-3', { 'opacity-0': !this.imgLoaded }]
        }, [createElement(this.titleEl, {
          props: { to: this.link }
        }, this.data.title)]))
      }
      if (this.description && !this.noCaption) {
        kids.push(createElement('figcaption', {
          'class': 'm0 left-align absolute left-0 top-100'
        }, this.description))
      }
      return createElement('figure', {
        'class': 'm0 relative'
      }, kids)
    } else {
      return createElement('div', {
        'class': 'max-width-3 h4 relative z3',
        domProps: {
          innerHTML: this.text
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/Slide.js